import { TLoadout } from "MVVM/Views/CreateMontage/@types";
import { atom } from "recoil";
import { persistAtom } from "./persist";

export const QuickEditTitle = atom<string>({
  key: "QuickEditTitle",
  default: "",
});

export const QuickEditPreferredLoadout = atom<TLoadout | null>({
  key: "QuickEditPreferredLoadoutV2",
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const QuickEditPreferredFinalTouches = atom<string[]>({
  key: "QuickEditPreferredFinalTouches",
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const QuickEditPreferredThumbnail = atom<string>({
  key: "QuickEditPreferredThumbnailV2",
  default: "",
  effects_UNSTABLE: [persistAtom],
});

export const QuickEditPreferredPresetId = atom<string | null>({
  key: "QuickEditPreferredPresetId",
  default: null,
  effects_UNSTABLE: [persistAtom],
});
